import { addDynamicControl, editDynamicControl, dynamicControlDetail } from './request';
export default {
  data() {
    return {
      dialogVisible: false,
      dataFrom: {},
      pageTypeList: []
    };
  },
  computed: {
    dataRule() {
      return {
        name: [{
          required: true,
          trigger: 'blur',
          message: this.$t('请输入') + this.$t('模板名称')
        }],
        pageType: [{
          required: true,
          message: this.$t('请选择') + this.$t('页面类型'),
          trigger: 'change'
        }]
      };
    }
  },
  methods: {
    async init(val, arr) {
      if (val) {
        const res = await dynamicControlDetail({
          id: val.id
        });
        this.dataFrom = {
          id: res.id,
          name: res.name,
          pageType: res.pageType
        };
      }
      this.pageTypeList = arr;
      this.dialogVisible = true;
    },
    handleSure() {
      this.$refs.dataFrom.validate(async valid => {
        if (valid) {
          const FUN = this.dataFrom.id ? editDynamicControl : addDynamicControl;
          await FUN(this.dataFrom);
          this.$message.success(this.$t('操作成功'));
          this.$emit('save');
          this.$emit('cancel');
        }
      });
    }
  }
};